import { getItemsFromApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getEmailAccountsSimple } from '../Email.api'
import { EmailAccountSelectDropdownListItem } from '../EmailAccountSelectDropdownListItem'

import { toEmailAccountSelectItems } from './EmailAccountSelect.utils'

function EmailAccountSelect({
  Control = InputSelectControl,
  getData = getEmailAccountsSimple,
  getDataItems = getItemsFromApiResponse,
  toPreparedItems = toEmailAccountSelectItems,
  ...restProps
}) {
  return (
    <>
      <InputAsyncSelect
        {...restProps}
        Control={Control}
        getData={getData}
        getDataItems={getDataItems}
        listProps={{
          ...restProps?.listProps,
          Item: EmailAccountSelectDropdownListItem,
        }}
        toPreparedItems={toPreparedItems}
      />
    </>
  )
}

export default EmailAccountSelect
